import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuCheckboxItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { stages } from "@/components/startup/startupConstants";

interface StageFilterProps {
  selectedStages: string[];
  onStageChange: (stages: string[]) => void;
}

export function StageFilter({ selectedStages, onStageChange }: StageFilterProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          Stage
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-40">
        <DropdownMenuLabel>Stage</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {stages.map((stage) => (
          <DropdownMenuCheckboxItem
            key={stage}
            checked={selectedStages.includes(stage)}
            onCheckedChange={(checked) => {
              const newStages = checked
                ? [...selectedStages, stage]
                : selectedStages.filter((s) => s !== stage);
              onStageChange(newStages);
            }}
          >
            {stage}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}